import { LogTextStatus } from "../../../../components/logText";
import SimpleCard from "../../../../components/simpleCard";
import LeasingStore from "../../../../contexts/leasingStore";
import _t from "../../../../lang/translate";
import LeasingGeneratePaymentAdviceRestValueDocument from "../leasingGeneratePaymentAdviceRestValue";
import LeasingActivationActions from "./leasingActivationActions";
import LeasingDealActiveSettings from "./leasingDealActiveSettings";
import LeasingDealExpireSettings from "./leasingDealExpireSettings";
import SendLeasingCode from "./sendLeasingCode";

export function LeasingAdminDealStart() {
  const { leasingCase, adminValues } = LeasingStore.useContainer();
  const { log } = leasingCase

  return (
    <div>
      <SimpleCard title={_t("start_information")}>
        <LeasingDealActiveSettings />
      </SimpleCard>

      <SimpleCard title={_t("leasing_code")}>
        <LogTextStatus log={adminValues?.logs?.leasingCodeSent}
          defaultLabel="Afventer afsendelse af leasingkode"
          logLabel={"Leasingkode afsendt"}
          by
          className="mb-05"
        />
        <SendLeasingCode />
      </SimpleCard>


      <SimpleCard className="mb-0" title={_t("activation_of_leasing_agreement")}>
        <LogTextStatus log={log?.active}
          defaultLabel="Afventer aktivering af leasingaftale"
          logLabel={"Leasingaftale markeret aktiveret"}
          by
          className="mb-05"
        />
        <LeasingActivationActions type="activated" />
      </SimpleCard>
    </div>
  );
}

export function LeasingAdminDealExpiration() {

  const { leasingCase, adminValues } = LeasingStore.useContainer();
  const { log } = leasingCase

  return (
    <>
      <SimpleCard title={_t("expiration_information")}>
        <LeasingDealExpireSettings />
      </SimpleCard>


      <SimpleCard title={_t("restValue")}>
        <LogTextStatus log={adminValues?.logs?.restValueAdviceSent}
          defaultLabel="Afventer afsendelse af restværdi advis"
          logLabel={"Restværdi advis afsendt"}
          by
          className="mb-05"
        />
        <LeasingGeneratePaymentAdviceRestValueDocument />
      </SimpleCard>


      <SimpleCard className="mb-0" title={_t("expire_leasing_deal")}>
        <LogTextStatus log={log?.expired}
          defaultLabel="Afventer udløb af leasingaftale"
          logLabel={"Leasingaftale markeret udløbet"}
          by
          className="mb-05"
        />
        <LeasingActivationActions type="expired" />
      </SimpleCard>
    </>
  );
}
